import React from 'react';
import { Box, Button, Card, CardContent, Container, Grid, Typography } from '@mui/material';
import {
  Code as CodeIcon,
  Webhook as WebhookIcon,
  Storage as StorageIcon
} from '@mui/icons-material';

const cards = [
  {
    icon: <CodeIcon sx={{ fontSize: 40, color: '#1976d2' }} />,
    title: 'Custom Functions',
    description: 'Build and deploy reusable business logic functions that integrate directly with extraction pipelines.',
    borderColor: 'rgba(25, 118, 210, 0.15)',
    hoverBorderColor: 'rgba(25, 118, 210, 0.3)',
    hoverBg: '#f0f8ff',
    hoverShadow: 'rgba(25, 118, 210, 0.2)'
  },
  {
    icon: <WebhookIcon sx={{ fontSize: 40, color: '#2e7d32' }} />,
    title: 'Webhooks & APIs',
    description: 'Deliver extraction results to any system via configurable webhooks with field mapping, custom headers, and auth.',
    borderColor: 'rgba(46, 125, 50, 0.15)',
    hoverBorderColor: 'rgba(46, 125, 50, 0.3)',
    hoverBg: '#f0f8f0',
    hoverShadow: 'rgba(46, 125, 50, 0.2)'
  },
  {
    icon: <StorageIcon sx={{ fontSize: 40, color: '#ed6c02' }} />,
    title: 'Services Registry',
    description: 'Deploy and manage backend services with lifecycle monitoring, real-time logs, and analytics built in.',
    borderColor: 'rgba(237, 108, 2, 0.15)',
    hoverBorderColor: 'rgba(237, 108, 2, 0.3)',
    hoverBg: '#fff8f0',
    hoverShadow: 'rgba(237, 108, 2, 0.2)'
  }
];

const CustomLogicSection = ({ navigate }) => (
  <Box
    sx={{
      py: 8,
      background: 'linear-gradient(135deg, #e3f2fd 0%, #d0e8fa 100%)',
      position: 'relative',
      zIndex: 1,
      borderTop: '1px solid rgba(25,118,210,0.12)',
      borderBottom: '1px solid rgba(25,118,210,0.12)'
    }}
  >
    <Container maxWidth="lg">
      <Typography variant="h3" align="center" sx={{ fontWeight: 700, mb: 2, color: '#1976d2' }}>
        Extend the Platform with Custom Logic
      </Typography>
      <Typography variant="body1" align="center" sx={{ color: '#555', mb: 6, maxWidth: 700, mx: 'auto', lineHeight: 1.6 }}>
        Build, deploy, and scale your custom business logic as functions and services that work seamlessly with the document intelligence pipeline.
      </Typography>
      <Grid container spacing={4}>
        {cards.map((card) => (
          <Grid item xs={12} md={4} key={card.title}>
            <Card
              sx={{
                height: '100%',
                borderRadius: 3,
                background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
                boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
                transition: 'all 0.4s ease-in-out',
                border: `1px solid ${card.borderColor}`,
                '&:hover': {
                  transform: 'translateY(-12px) rotate(1deg)',
                  boxShadow: `0 16px 40px ${card.hoverShadow}`,
                  background: `linear-gradient(135deg, #ffffff 0%, ${card.hoverBg} 100%)`,
                  border: `1px solid ${card.hoverBorderColor}`
                }
              }}
            >
              <CardContent sx={{ p: 3, textAlign: 'center' }}>
                <Box sx={{ mb: 2 }}>{card.icon}</Box>
                <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, color: '#000' }}>
                  {card.title}
                </Typography>
                <Typography variant="body2" sx={{ color: '#333', lineHeight: 1.6 }}>
                  {card.description}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
      <Box sx={{ mt: 6, textAlign: 'center' }}>
        <Button
          variant="outlined"
          size="large"
          onClick={() => navigate('/registration')}
          sx={{
            borderRadius: 3,
            px: 4,
            py: 1.5,
            textTransform: 'none',
            fontWeight: 600,
            fontSize: '1.1rem',
            border: '2px solid rgba(25, 118, 210, 0.6)',
            color: '#1976d2',
            background: 'rgba(25, 118, 210, 0.05)',
            '&:hover': {
              background: 'rgba(25, 118, 210, 0.1)',
              border: '2px solid rgba(25, 118, 210, 0.8)',
              transform: 'translateY(-2px)',
              boxShadow: '0 6px 20px rgba(25, 118, 210, 0.3)'
            },
            transition: 'all 0.3s ease'
          }}
        >
          Start Building
        </Button>
      </Box>
    </Container>
  </Box>
);

export default CustomLogicSection;
